import defaultWebQuantity from '#themes/default/web/components/quantity/quantity.js';

import cInput from '#themes/avast/web/components/input/input.js';
import cSvg from '#themes/avast/web/components/svg/svg.js';
import cTooltip from '#themes/avast/web/components/tooltip/tooltip.js';

export default {
	components: {
		cInput,
		cSvg,
		cTooltip
	},
	extends: defaultWebQuantity
};
